import axiosInstance from "~/shared/api/axios-instance";

/**
 * 화각 조정 (adjustment_status) 만 변경하는 PATCH.
 * adjustment 가 객체면 set, null 이면 wipe. 다른 필드(floor_plan_id, position, extra_camera_orientation_status)는 서버 값 보존.
 */
export const updateCameraAdjustment = async (params: {
  branchUid: string;
  versionId?: number;
  cameraOrientationId: number;
  adjustment: {
    adjustmentId: string;
    position: { x: number; y: number; rotation: number };
    frame: { dx: number; dy: number };
  } | null;
}) => {
  // 빈 adjustment_id 는 server 가 받아주지만 fetch 후 falsy 체크에 걸려 라벨/ghost 가 사라짐 → unique 값 fallback
  const resolvedAdjustmentId =
    params.adjustment?.adjustmentId && params.adjustment.adjustmentId.length > 0
      ? params.adjustment.adjustmentId
      : String(Date.now()) + Math.floor(Math.random() * 1000);
  const body: Record<string, unknown> = {
    version: params.versionId,
    adjustment_status: params.adjustment
      ? {
          adjustment_id: resolvedAdjustmentId,
          position: {
            x: params.adjustment.position.x,
            y: params.adjustment.position.y,
            rotation: params.adjustment.position.rotation,
          },
          frame: {
            dx: params.adjustment.frame.dx,
            dy: params.adjustment.frame.dy,
          },
        }
      : null,
  };
  const { data } = await axiosInstance.patch(
    `branches/${params.branchUid}/pseudo-camera-orientations/${params.cameraOrientationId}/`,
    body,
  );
  return data;
};
